import { connect } from "react-redux";
import { appSetWlf, appSetConfig, appSetDemoMode } from "../app/actions";
import Component from "./Home";
import { navigatePath } from "../nav/actions";
import { updateClient } from "../store/reducers/client";
import {dispatch_logout} from "../app/logout-dispatch";

function mapDispatchToProps(dispatch) {
  return({
    appSetWlf: wlf => { dispatch(appSetWlf(wlf))},
    navigatePath: path => { dispatch(navigatePath(path))},
    updateClient: (css) => { dispatch(updateClient(css))},
    appSetConfig: config => { dispatch(appSetConfig(config))},
    appSetDemoMode: val => { dispatch(appSetDemoMode(val)) },
    logout: () => { dispatch_logout(dispatch) },
  })
}

function mapStateToProps(state) {
  return {
    wlfs: state.wlfs,
    app: state.app,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)